import "./TeamView.css";
import React, { useEffect, useState } from "react";
import Navbar from "../../component/navbar/Navbar";
import Footer from "../../component/footer/Footer";
import FlexBox from "../../component/flexbox/FlexBox";
import ViewTitle from "../../component/title/view/ViewTitle";
import { StaffMember, ROLE_CONFIG } from "./types";
import fetchWithRetry from "../../util/request";
import Title from "../../component/title/Title";
import { useTranslation } from "react-i18next";

export default function TeamView() {
    const { t } = useTranslation();
    const [staffMembers, setStaffMembers] = useState<StaffMember[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const cancelFetch = fetchWithRetry(async res => {
            if (!res.ok) return false;
            const data = await res.json();
            setStaffMembers(data);
            setLoading(false);
            return true;
        }, "https://api.ptero-cloud.net/data/staff");

        return () => {
            cancelFetch();
        };
    }, []);

    // Group staff members by role
    const groupedStaff = staffMembers.reduce((acc, member) => {
        if (!acc[member.group]) {
            acc[member.group] = [];
        }
        acc[member.group].push(member);
        return acc;
    }, {} as Record<string, StaffMember[]>);

    // Sort roles by order defined in ROLE_CONFIG
    const sortedRoles = Object.keys(groupedStaff).sort((a, b) => {
        const orderA = ROLE_CONFIG[a]?.order ?? 999;
        const orderB = ROLE_CONFIG[b]?.order ?? 999;
        return orderA - orderB;
    });

    return (
        <div className="team-view">
            <Navbar />
            <ViewTitle><Title>{t("team.title")}</Title></ViewTitle>
            <div className="team-content">
                {loading ? (
                    <div className="team-loading">{t("team.loading")}</div>
                ) : (
                    <FlexBox direction="column" gap={32} className="team-roles">
                        {sortedRoles.map(role => {
                            const roleConfig = ROLE_CONFIG[role];
                            if (!roleConfig) return null;
                            const roleName = t(`team.roles.${role}`, roleConfig.name);

                            return (
                                <div key={role} className="team-role-section">
                                    <h2
                                        className="team-role-title"
                                        style={{ color: roleConfig.color }}
                                    >
                                        {roleName}
                                    </h2>
                                    <div className="team-members-grid">
                                        {groupedStaff[role].map(member => (
                                            <div key={member.uuid} className="team-member-card">
                                                <img
                                                    src={`https://minotar.net/helm/${member.uuid}/100.png`}
                                                    alt={member.name}
                                                    className="team-member-avatar"
                                                />
                                                <div className="team-member-info">
                                                    <span className="team-member-name">{member.name}</span>
                                                    <span
                                                        className="team-member-role"
                                                        style={{ color: roleConfig.color }}
                                                    >
                                                        {roleName}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </FlexBox>
                )}
            </div>
            <Footer />
        </div>
    );
}
